// NOTE: DEPRECATED: use ActionButton instead


import React from 'react';
import Link from '../Link';

export default class Blocklink extends React.Component {
    render() {
        var classes = ['blocklink', this.props.className],
            style = Object.assign({}, this.props.style);

        classes.push(this.props.color);
        if (this.props.icon) {
            classes.push('hasIcon');
            classes.push('icon-' + this.props.icon);
        }
        if (this.props.next) {
            classes.push('next');
        }
        if (this.props.right) {
            classes.push('text-right');
        }

        var customColor;
        if (this.props.customColor) {
            customColor = (
                <div
                    className="custom-color"
                    style={{
                        backgroundColor: this.props.customColor,
                    }}
                ></div>
            );
        }

        if (this.props.href) {
            return (
                <Link href={this.props.href} disabled={this.props.disabled}>
                    <button
                        type={this.props.type || 'button'}
                        className={classes.join(' ')}
                        onClick={() => {
                            if (this.props.onClick) {
                                this.props.onClick();
                            }
                        }}
                        style={style}
                        disabled={this.props.disabled}
                    >
                        {customColor}
                        {this.props.children}
                    </button>
                </Link>
            );
        } else {
            return (
                <button
                    type={this.props.type || 'button'}
                    className={classes.join(' ')}
                    onClick={() => {
                        if (this.props.onClick) {
                            this.props.onClick();
                        }
                    }}
                    style={style}
                    disabled={this.props.disabled}
                >
                    {customColor}
                    {this.props.children}
                </button>
            );
        }
    }
}

Blocklink.defaultProps = {
    className: '',
    color: 'mixed',
    type: 'button',
};
